// extracted by mini-css-extract-plugin
module.exports = {"suggestion-list":"_3wYCX","suggestionList":"_3wYCX"};